export const AssignmentDocumentType = {
  ComandaFermaTip1: "comanda_ferma_tip1",

  ComandaFermaTip2: "comanda_ferma_tip2",
  ContractTip2: "contract_tip2",

  ComandaFermaTip3: "comanda_ferma_tip3",
  ContractTip3: "contract_tip3",

  ComandaFermaTip4: "comanda_ferma_tip4",
  ContractTip4: "contract_tip4",

  ComandaFermaTipSocial: "comanda_ferma_tip_social",
  ContractTipSocial: "contract_tip_social",

  ComandaFermaArt31: "comanda_ferma_art31",
  ContractArt31: "contract_art31",
};
